import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../sagas/sagaActions';
import { useAppDispatch } from '../store/hooks';
import { CheckIcon, GlobeIcon } from './icons';
import styles from './LanguageSwitcher.module.scss';
import { LANGUAGES } from './languages';

export function LanguageSwitcher() {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) {
      return;
    }

    const onPointerDown = (e: MouseEvent) => {
      if (!wrapperRef.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  return (
    <div className={styles.wrap} ref={wrapperRef}>
      <button
        type="button"
        className={styles.navBtn}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <GlobeIcon className={styles.navIcon} />
        {i18n.language.toUpperCase()}
      </button>

      {open && (
        <div className={styles.panel} role="menu">
          {LANGUAGES.map((language) => {
            const active = language.code === i18n.language;
            return (
              <button
                key={language.code}
                type="button"
                role="menuitem"
                aria-current={active}
                className={styles.option}
                onClick={() => {
                  dispatch(setLanguage(language.code));
                  setOpen(false);
                }}
              >
                <span className={styles.checkSlot}>
                  {active && <CheckIcon className={styles.checkIcon} />}
                </span>
                {language.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
